import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

import { BP42InitialState } from '~/src/packages/bp42/reducer/initialState';

const getProducts = (state: BP42InitialState): EProductsId[] => state.selectedProducts;

export default getProducts;
